import React from "react";
import Icon from "../../ui/Icon/Icon";
import styles from "./confirm-section.module.css";
import Button from "../../ui/Button/Button";
import { useTranslation } from "react-i18next";

/**
 * ConfirmSection - A component for confirmation dialogs with two buttons
 * 
 * @param {Object} props
 * @param {React.ReactNode} props.icon - Icon to display (defaults to question icon)
 * @param {string} props.title - Main title text
 * @param {string} props.descriptionLine1 - First line of description
 * @param {string} props.descriptionLine2 - Second line of description (optional)
 * @param {Function} props.onConfirm - Function to call when confirm button is clicked
 * @param {Function} props.onCancel - Function to call when cancel button is clicked
 * @param {string} props.confirmButtonText - Text for the confirm button (default: "ยืนยัน")
 * @param {string} props.cancelButtonText - Text for the cancel button (default: "ยกเลิก")
 * @param {string} props.className - Additional CSS class
 */
const ConfirmSection = ({
  
  icon = <Icon size={72} name="ico-question-circle" />,
  title,
  descriptionLine1,
  descriptionLine2,
  onConfirm,
  onCancel,
  confirmButtonText = "ยืนยัน",
  cancelButtonText = "ยกเลิก",
  className,
}) => {
  return (
    <section className={styles.confirmContainer}>
      <div className={styles.confirmContent}>
        {icon}

        <h2 className={styles.confirmTitle}>{title}</h2>

        <p className={styles.confirmMessage}>
          {descriptionLine1}
          {descriptionLine2 && (
            <>
              <br />
              {descriptionLine2}
            </>
          )}
        </p>

        <div className={styles.buttonGroup}>
          <Button 
            onClick={onConfirm} 
            textColor="#667085"
            fullWidth
          >
            {confirmButtonText}
          </Button>
          
          <Button 
            onClick={onCancel}
            variant="primary"
            fullWidth
          >
            {cancelButtonText}
          </Button>
        </div>
      </div>
    </section>
  );
};

export default ConfirmSection; 